

// @ts-nocheck

import Vue from "vue";
import check from "./SVGs/Check.vue";
import info from "./SVGs/Info.vue";
import { decode } from "../../../../../../../Overarching Resources/TS/Survey/surveyHelperMethods";

export default Vue.extend({
  data() {
    return {
      tipsLocal: [] as any[],
    };
  },
  props: {
    fieldAddress: Array,
  },
  computed: {
    tips: {
      get: function (): any[] | false {
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: any[] | false): void {
        this.$store.commit("survey/CHANGE_FIELD", {
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  components: {
    info,
    check,
  },
  methods: {
    changePic(i: number, picSource: string): void {
      this.tipsLocal[i].picSource = picSource;
    },
    addTip(): void {
      this.tipsLocal.push({
        picSource: "check",
        originalEncoded: false,
        originalDecoded: false,
        text: "",
      });
    },
    removeTip(i: number) {
      this.tipsLocal.splice(i, 1);
    },
  },
  created() {
    // welcome back. For each tip check if it's encoded. If so, use it's string,
    // and record it's initial values

    // if it changes back to initial values, reuse the encoded value

    if (this.tips === false) {
      this.tipsLocal = [];
    } else {
      const newTips = [] as any[];
      let decoded;

      this.tips.forEach((tp) => {
        decoded = decode(tp.text as string);
        if (decoded) {
          //official language field
          const decodedText = this.$store.getters["dash/specificLanguagePack"](
            decoded.languagePackSlug
          )[decoded.slug];
          newTips.push({
            picSource: tp.picSource,
            originalEncoded: tp.text,
            originalDecoded: decodedText,
            text: decodedText,
          });
        } else {
          newTips.push({
            picSource: tp.picSource,
            originalEncoded: false,
            originalDecoded: false,
            text: tp.text,
          });
        }
      });
      // @ts-ignore
      this.tipsLocal = newTips;
    }
  },
  watch: {
    tipsLocal: {
      handler(v) {
        //check if encoded values changed, if not reuse them
        //remove unused fields from local tips
        let valToPush = [] as any;

        if (this.tipsLocal.length === 0) {
          valToPush = false;
        } else {
          this.tipsLocal.forEach((tpL) => {
            let textValue = tpL.text;

            if (textValue === tpL.originalDecoded) {
              textValue = tpL.originalEncoded;
            }

            if (textValue.trim())
              valToPush.push({
                text: textValue,
                picSource: tpL.picSource,
              });
          });
        }

        this.tips = valToPush;
        
        setTimeout(() => {
          // @ts-ignore //errors not picked up
          if (this.errors.any()) {
            this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: true});
          } else {
            this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: false});
          }
        }, 1);

      },
      deep: true,
    },
  },
});
